import React from "react";

function ContactPage() {
  return (
    <div className="flex flex-col md:flex-row text-palette_color2 w-full max-w-4xl mx-auto bg-[#393C41] rounded-2xl shadow-lg overflow-hidden">
      {/* Address and Map */}
      <div className="flex-1 flex flex-col items-center p-6 md:p-8">
        <div className="mb-4 w-full">
          <h3 className="font-robo font-semibold text-base text-white mb-1">Comsats University Lahore</h3>
          <p className="font-robo text-xs text-gray-200 whitespace-pre-line break-words">
            1.5 KM Defence Rd, off Raiwand Road, Lda Avenue Phase 1 Lda Avenue, Lahore, Punjab 54000, Pakistan.
          </p>
        </div>
        <img
          className="rounded-xl shadow w-full max-w-xs md:max-w-sm object-cover mt-2"
          src={require("../assets/map.jpeg")}
          alt="Comsats University Lahore Map"
        />
      </div>
      {/* Contact Info */}
      <div className="flex-1 flex flex-col justify-center p-6 md:p-8 border-t md:border-t-0 md:border-l border-secondary bg-[#393C41]">
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center">
            <span className="font-robo text-white text-sm w-24">Email:</span>
            <a
              href="mailto:help.chatdev@gmail.com"
              className="font-robo text-sm text-gray-200 hover:text-blue-400 break-all ml-0 sm:ml-2"
              target="_blank"
              rel="noreferrer noopener"
            >
              help.chatdev@gmail.com
            </a>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center">
            <span className="font-robo text-white text-sm w-24">Contact no.:</span>
            <span className="font-robo text-sm text-gray-200 ml-0 sm:ml-2">+92 334 0100049</span>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center">
            <span className="font-robo text-white text-sm w-24">Twitter:</span>
            <a
              href="https://twitter.com/hassaan_asif_kh"
              className="font-robo text-sm text-gray-200 hover:text-blue-400 ml-0 sm:ml-2"
              target="_blank"
              rel="noreferrer noopener"
            >
              Twitter
            </a>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center">
            <span className="font-robo text-white text-sm w-24">LinkedIn:</span>
            <a
              href="https://www.linkedin.com/in/hassaan-asif-khan-3305a9175/"
              className="font-robo text-sm text-gray-200 hover:text-blue-400 ml-0 sm:ml-2"
              target="_blank"
              rel="noreferrer noopener"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
